import React, { CSSProperties } from 'react';
import { IBlock, IBlockData } from '../../../typings';
import { BasicType } from '../../../constants';
import { merge } from 'lodash';
import { createBlock, t } from '../../../utils';
import { BasicBlock } from '../../../components/BasicBlock';

export type IImage = IBlockData<{
    alt?: string;
    src?: string;
    title?: string;
    href?: string;
    target?: string;
    border?: string;
    height?: string;
    'text-decoration'?: string;
    'text-transform'?: CSSProperties['textTransform'];
    align?: CSSProperties['textAlign'];
    'container-background-color'?: string;
    width?: string;
    padding?: string;
}>;

export const Image: IBlock<IImage> = createBlock({
    get name() {
        return t('Image');
    },
    type: BasicType.IMAGE,
    create: (payload: any) => {
        const defaultData: IImage = {
            type: BasicType.IMAGE,
            data: {
                value: {},
            },
            attributes: {
                align: 'center',
                height: 'auto',
                padding: '10px 25px 10px 25px',
                src: '',
            },
            children: [],
        };
        return merge(defaultData, payload);
    },
    validParentType: [BasicType.COLUMN, BasicType.HERO],
    render(params: any) {
        return (
            <BasicBlock
                params={params}
                tag='mj-image'
            />
        );
    },
});
